/* ══════════════════════════════════════════════════════════════
   Page Shell — Wrapper for all pages (header + content area)
   ══════════════════════════════════════════════════════════════ */

export interface PageShellOptions {
    title: string;
    icon: string;
    subtitle?: string;
    actions?: string; // HTML for action buttons
}

export function renderPageShell(options: PageShellOptions, content: string): string {
    const { title, icon, subtitle, actions } = options;

    return `
    <div class="page-shell animate-fade-in">
      <header class="page-shell__header">
        <div class="page-shell__title-area">
          <h1 class="page-shell__title">${icon} ${title}</h1>
          ${subtitle ? `<p class="page-shell__subtitle">${subtitle}</p>` : ''}
        </div>
        ${actions ? `<div class="page-shell__actions">${actions}</div>` : ''}
      </header>
      <main class="page-shell__content stagger-children">
        ${content}
      </main>
    </div>
  `;
}

// PageShell CSS (injected once)
export const PAGE_SHELL_STYLES = `
  .page-shell__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: var(--space-6);
    flex-wrap: wrap;
    gap: var(--space-4);
  }

  .page-shell__title {
    font-family: var(--font-display);
    font-size: var(--text-2xl);
    font-weight: 700;
    color: var(--text-primary);
  }

  .page-shell__subtitle {
    font-size: var(--text-sm);
    color: var(--text-muted);
    margin-top: var(--space-1);
  }

  .page-shell__actions {
    display: flex;
    gap: var(--space-2);
    align-items: center;
  }

  .page-shell__content {
    min-height: 400px;
  }
`;
